export const GOOGLE_MAPS_PRODUCTION_KEY = 'AIzaSyBRZRZ6swoNMcV9Q_x7SZWpnIejgygT5G8';
export const GOOGLE_MAPS_DEV_KEY = 'AIzaSyAB1gfMe1mwNoRlHRjcltka1hjZRXVrWK4';
export const ALRIYADH_LATLNG = { lat: 24.7324157, lng: 46.7239522 };
export const MOBILE_MEDIA_QUERY = '(max-width: 768px)';
export const MIXPANEL_TESTING_TOKEN = '9d1ed94c25979a8810d933b7e5868f1a';
export const MIXPANEL_PROD_TOKEN = '8bff35573d4c6a6d6b4342a052a0b1e1';
export const PRODUCTSFRUIT_PROD_TOKEN = 'fE6P0P3s6MTLzAFP';
export const PRODUCTSFRUIT_TESTING_TOKEN = 'fE6P0P3s6MTLzAFP';
